<template>
  <div>
    <v-select
      ref="vselect"
      v-model="selected"
      :items="datasource"
      :label="$t('fields.'+fieldName)"
      multiple
      :chips="chips"
      :hint="$t(hint)"
      persistent-hint
      hide-details
      :item-text="item => noTranslate ? item.name : $t(translateSource + '.' + item.name)"
      :item-value="returnValue"
      :return-object="returnObject"
      v-on="$listeners"
    >
      <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="toggle"
        >
          <v-list-item-action>
            <v-icon :color="selected.length > 0 ? 'indigo darken-4' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('select_all') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2" />
      </template>
    </v-select>
  </div>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'

  export default {
    name: 'ListSelector',
    model: {
      prop: 'selected',
      event: 'selectedchange',
    },
    props: {
      fieldName: String,
      sourceType: String,
      hint: String,
      returnObject: Boolean,
      returnValue: {
        type: String,
        default: 'name',
      },
      chips: {
        type: Boolean,
        default: false,
      },
      translateSource: {
        type: String,
        default: 'fields',
      },
      noTranslate: {
        type: Boolean,
        default: false,
      },
      selectedSource: {
        type: Array,
        default () {
          return []
        },
      },
    },
    data () {
      return {
        datasource: [],
        // selected: [], // $refs.vselect.value.length
      }
    },
    computed: {
      likesAllItem () {
        return this.selected.length === this.datasource.length
      },
      likesSomeItem () {
        return this.selected.length > 0 && !this.likesAllItem
      },
      icon () {
        if (this.likesAllItem) return 'mdi-close-box'
        if (this.likesSomeItem) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      selected: {
        get: function () {
          return this.selectedSource
        },
        set: function (value) {
          this.$emit('selectedchange', value)
        },
      },
    },
    mounted () {
      this.fetchDatasource({ sourceType: this.sourceType }).then(response => {
        this.datasource = response.sort((a, b) => {
          const fa = this.noTranslate ? a.name : this.$t(this.translateSource + '.' + a.name)
          const fb = this.noTranslate ? b.name : this.$t(this.translateSource + '.' + b.name)
          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }
          return 0
        })
      })
    },
    methods: {
      fetchDatasource: call('datasource/fetchDatasource'),
      toggle () {
        this.$nextTick(() => {
          if (this.likesAllItem) {
            this.selected = []
          } else {
            if (this.returnObject) {
              this.selected = this.datasource
            } else {
              this.selected = this.datasource.slice().map(o => { return o[this.returnValue] })
            }
          }
        })
      },
    },
  }
</script>
